import portaro from '../portaro';

portaro.directive('jpHideAloneHeaders', ['$timeout',
    function($timeout) {

        var hideAloneHeaders = function(tableElem) {
            var thElems = tableElem.find("thead tr").children();
            var trElems = tableElem.find("tbody tr");

            for(var colIdx = 0; colIdx < thElems.length; colIdx++) {
                if (hasAnyShowableCell(trElems, colIdx))
                    continue;
                thElems.eq(colIdx).html(""); //pozdeji asi zmenit na pridani/odebrani specialni classy - kvuli nefunkncni reverzni funkci - pri doplneni property se zustane prazdny header
            }
        };

        var hasAnyShowableCell = function(trElems, colIdx) {
            for(var rowIdx = 0; rowIdx < trElems.length; rowIdx++) {
                var trElem = trElems.eq(rowIdx);
                var tdElem = trElem.find("td").eq(colIdx);
                if (!isEmptyElement(tdElem))
                    return true;
            }
            return false;
        };

        /**
         * Hlavni fce, zjistujici, zda je element prazdny.
         * @param {type} elem
         * @returns {Boolean}
         */
        var isEmptyElement = function(elem) {
            if (elem.find("button").length > 0) {
                return false;
            }
            return elem.text().trim().length === 0;
        };

        return {
            restrict: 'A',
            scope: {data: '=jpHideAloneHeaders'},
            link: function(scope, element, attrs) {
                scope.$watch('data', function() {
                    scope.$evalAsync(function() { //pokud nebude fungovat, tak pouzit $timeout, ktery by se mel zavolat az po vyrenderovani DOMu
                        hideAloneHeaders(element);
                    });
                });
            }
        };
    }]);